import util from '@bmp-vue/core/api/util'

const controller = 'OperadorFrontEndContaExcecaoHorario'
export default Object.assign({}, util.GetCrud(controller, null), {
    ObterPorContaOperador: function (dto) {
        return util.Axios.Get(`${controller}/PorContaOperador?codigoConta=${dto.codigoConta}&codigoOperador=${dto.codigoOperador}`)
    }
})
